<template>
	<div v-if="orderrowData">
		<v-row>
			<v-col>
				<h1><translate>Policy cancelled</translate> {{ orderrowData.identifier }}</h1>
			</v-col>
		</v-row>
		<v-row>
			<v-col>
				<translate
					:translate-params="{date: (new Date(orderrowData.maxDate)).toLocaleDateString('nl-NL', {
						day: '2-digit', month: '2-digit', year: 'numeric'
					})}"
				>
					Your insurance has been ended per %{date}. An email has been sent to you with a confirmation.
				</translate>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import {
	axios,
} from '../../services/axios-service';

export default {
	name: 'CancelledPolicy',

	data () {
		return {
			orderrowId: null,
			orderrowData: null
		};
	},

	mounted () {
		this.orderrowId = new URLSearchParams(window.location.search.substring(1)).get('id');
		this.getOrderrowData();
	},

	methods: {
		/**
		 * Get the minimum, maximum, and suggested cancellation date
		 *
		 * @returns {void}
		 */
		getOrderrowData () {
			axios.get('/api/v0/orderrows/canceldata', {
				'params': {
					'id': this.orderrowId
				}
			}).then(({
				data: orderrowData
			}) => {
				this.orderrowData = orderrowData;
			}).catch((error) => {
				window.Sentry.captureException(error);
			});
		}
	}
};
</script>
